import { render, staticRenderFns } from "./CandleFiles.vue?vue&type=template&id=0c7e0022&scoped=true"
import script from "./CandleFiles.vue?vue&type=script&lang=js"
export * from "./CandleFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7e0022",
  null
  
)

export default component.exports